import request from '@/utils/axios'

// { data: { range: this.fetchParam.range, page: this.fetchParam.currentPage, filter: this.fetchParam.filter } }
// const urlGetTransform = function (baseurl, payload) {
//   var url = baseurl
//   if (payload !== null) {
//     url += '&page=' + payload.page
//     url += '&start_date=' + payload.range.start
//     url += '&end_date=' + payload.range.end
//     url += '&filter_target=' + payload.filter.target
//     url += '&filter_sort=' + payload.filter.sort
//     url += '&query=' + payload.query
//   }
//   return url
// }

export default {
  createInit: ({ commit }) => {
    commit('SET_ARTICLE_STATE', true)
  },
  clearArticleList: ({ commit }) => {
    commit('SET_ARTICLES', [])
  },
  getTranslatedArticle: ({ commit }, { lang, originId }) => {
    return new Promise((resolve, reject) => {
      commit('SET_ARTICLE_STATE', false)
      var url = `/v1/translated-article/lang/${lang}/${originId}`
      request().get(url)
        .then((result) => {
          console.log(result)
          commit('SET_ARTICLE', result.data)
          resolve(result.data)
          commit('SET_ARTICLE_STATE', true)
        })
        .catch((err) => {
        // console.log(err)
          reject(err)
          commit('SET_ARTICLE_STATE', true)
        })
    })
  },
  findArticles: ({ commit }, { data }) => {
    return new Promise((resolve, reject) => {
      commit('SET_ARTICLE_STATE', false)
      request().post('/v1/translated-article/find', data)
        .then((result) => {
          commit('SET_ARTICLES', result.data)
          resolve(result.data)
          commit('SET_ARTICLE_STATE', true)
        })
        .catch((err) => {
          // console.log(err)
          reject(err)
          commit('SET_ARTICLE_STATE', true)
        })
    })
  },
  getArticleById: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      commit('SET_ARTICLE_STATE', false)
      request().get('/v1/translated-article/show/' + id)
        .then((result) => {
          commit('SET_ARTICLE', result.data)
          resolve(result.data)
          commit('SET_ARTICLE_STATE', true)
        })
        .catch((err) => {
        // console.log(err)
          reject(err)
          commit('SET_ARTICLE_STATE', true)
        })
    })
  },
  addArticle: ({ commit }, { form }) => {
    return new Promise((resolve, reject) => {
      commit('SET_ARTICLE_STATE', false)
      request().post('/v1/translated-article/create', form)
        .then((result) => {
          resolve(result.data)
          commit('SET_ARTICLE_STATE', true)
        })
        .catch((err) => {
        // console.log(err)
          reject(err)
          commit('SET_ARTICLE_STATE', true)
        })
    })
  },
  updateTranslatedArticleStatus: ({ commit }, { lang, originId, form }) => {
    return new Promise((resolve, reject) => {
      commit('SET_ARTICLE_STATE', false)
      request().put(`/v1/translated-article/lang/${lang}/update-status/${originId}`, form)
        .then((result) => {
          // commit('SET_CATEGOORIES', result.data)
          resolve(result.data)
          commit('SET_ARTICLE_STATE', true)
        })
        .catch((err) => {
        // console.log(err)
          reject(err)
          commit('SET_ARTICLE_STATE', true)
        })
    })
  },
  updateTranslatedArticle: ({ commit }, { lang, originId, form }) => {
    return new Promise((resolve, reject) => {
      commit('SET_ARTICLE_STATE', false)
      request().put(`/v1/translated-article/lang/${lang}/update/${originId}`, form)
        .then((result) => {
          // commit('SET_CATEGOORIES', result.data)
          resolve(result.data)
          commit('SET_ARTICLE_STATE', true)
        })
        .catch((err) => {
        // console.log(err)
          reject(err)
          commit('SET_ARTICLE_STATE', true)
        })
    })
  },
  updateTranslatedThumbnail: ({ commit }, { form }) => {
    return new Promise((resolve, reject) => {
      commit('SET_ARTICLE_STATE', false)
      var lang = form.get('lang')
      var origin = form.get('origin')
      request().put(`/v1/translated-article/update-translated-thumbnail/${lang}/${origin}`, form)
        .then((result) => {
          // commit('SET_CATEGOORIES', result.data)
          resolve(result.data)
          commit('SET_TRANSLATED_THUMBNAIL', result.data.data.thumbnail)
          commit('SET_ARTICLE_STATE', true)
        })
        .catch((err) => {
        // console.log(err)
          reject(err)
          commit('SET_ARTICLE_STATE', true)
        })
    })
  }
}
